import { company } from '~/company/Company';

import Onboarding from '../Onboarding/Onboarding';

import { CityDrinksOnboarding } from './variants/CityDrinks/CityDrinksOnboarding';
import { DefaultOnboarding } from './variants/Default/DefaultOnboarding';
import { MCosmeticOnboarding } from './variants/MCosmetic';

export default company.match({
  citydrinks: CityDrinksOnboarding,
  mcosmetic: MCosmeticOnboarding,
  v3: DefaultOnboarding,
  default: Onboarding,
});
